import React, { useState, useContext } from "react";

export const tablePageNumber = React.createContext(null);

export const UseTablePageNumber = () => {
  const pc = useContext(tablePageNumber);
  if (pc === null) {
    throw new Error("useRefetchState Must be inside of Provider");
  }
  return pc;
};

const SavePageNumberOfSuperyProducts = ({ children }) => {
  const [page, setPage] = useState(parseInt(localStorage.getItem('pageNumber')));
  const closeIt = () => {
    localStorage.setItem('pageNumber', page);
  };
  window.onbeforeunload = closeIt;
  return (
    <tablePageNumber.Provider
      value={{
        page,
        setPage: (value) => {
          setPage(value);
        },
      }}
    >
      {children}
    </tablePageNumber.Provider>
  );
};

export {SavePageNumberOfSuperyProducts}
